module.exports = __webpack_public_path__ + "static/media/2020-09-01 21.46.32.a6b74ce1.jpg";